import { CreditUsageType } from '@aibees/shared/definition';
import type { IconName } from '@aibees/shared/components/icon/types';

export interface CreditCategory {
  title: string;
  icon: IconName;
  types: CreditUsageType[];
}

export const CREDIT_CATEGORY_DEFINITIONS: CreditCategory[] = [
  {
    title: 'Data Enrichment',
    icon: 'view-in-ar',
    types: [
      CreditUsageType.CONTACT_PROFILE_REVEAL,
      CreditUsageType.CONTACT_STORAGE_ENRICH,
      CreditUsageType.ACCOUNT_STORAGE_ENRICH,
      CreditUsageType.CONTACT_PROFILE_UPDATE,
    ],
  },
  {
    title: 'Contact Verification',
    icon: 'view-in-ar',
    types: [
      CreditUsageType.CONTACT_EMAIL_FINDING,
      CreditUsageType.CONTACT_PHONE_FINDING,
      CreditUsageType.CONTACT_EMAIL_REVERIFICATION,
      CreditUsageType.CONTACT_EMAIL_GUESS_RETRIEVAL,
    ],
  },
  {
    title: 'AI Intelligence & Insights',
    icon: 'outline-auto-awesome',
    types: [
      CreditUsageType.CONTACT_ANALYSIS_REVEAL,
      CreditUsageType.CONTACT_ANALYSIS_UPDATE,
      CreditUsageType.CONTACT_STORAGE_AI,
    ],
  },
  {
    title: 'Data Storage & Structuring',
    icon: 'data',
    types: [
      CreditUsageType.CONTACT_STORAGE_BASIC,
      CreditUsageType.ACCOUNT_STORAGE_BASIC,
      CreditUsageType.ACCOUNT_STORAGE_AI,
    ],
  },
];
